module.exports = __webpack_public_path__ + "static/media/registro_saude.6236a6be.png";